const selector = "#collection-products";
let cacheManager = {};

window.addEventListener('pageshow', function(e){
  onLoad(e);
});

function onLoad(e){
  cacheManager = new PageCacheManager(
    { 
      bodySelector: selector,
      onLoaded: onLoadedCache,
      onCached: onCachedCache,
    }
  );
  
  if(!e.persisted)
  {
    document.addEventListener('click',function(e){
      const closest = e.target.closest("#product-grid .card-wrapper");
      if(closest) cacheManager.cachePage();
    });
  }
}

function infiniteScrollCollection() {
  var endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#CollectionPagination',
    method: 'scroll',
    loadingText: '',
    offset: 1000
  });
}

function onLoadedCache(e){
  infiniteScrollCollection();
  document.querySelector(selector).style.visibility = 'visible';
};

function onCachedCache(e){
  console.log('cached');
};